/**
 * Document revision status configuration
 * Domain-specific constants for document status management
 */

import { DocumentRevisionStatus, DocumentRevisionStatusLabels } from '@/shared/lib';

export type DocumentStatusListItem = {
  label: string;
  value: string;
};

let _statusList: DocumentStatusListItem[] | null = null;

export function getStatusList(): readonly DocumentStatusListItem[] {
  if (!_statusList) {
    _statusList = [
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.CURRENT],
        value: DocumentRevisionStatus.CURRENT,
      },
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.OBSOLETE],
        value: DocumentRevisionStatus.OBSOLETE,
      },
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.FAILED_VERIFICATION],
        value: DocumentRevisionStatus.FAILED_VERIFICATION,
      },
      {
        label: DocumentRevisionStatusLabels[DocumentRevisionStatus.INACTIVE],
        value: DocumentRevisionStatus.INACTIVE,
      },
    ];
  }
  return _statusList;
}

export const STATUS_LIST = new Proxy([], {
  get(_, prop) {
    const list = getStatusList();
    if (prop === 'length') return list.length;
    if (typeof prop === 'string' && !isNaN(Number(prop))) return list[Number(prop)];
    return (list as any)[prop];
  },
}) as unknown as readonly DocumentStatusListItem[];
